import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { Constants } from 'app/shared/constant/constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { ToastrService } from "ngx-toastr";
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'international-sim',
  templateUrl: './esim-page.component.html',
  styleUrls: ['./esim-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class ESIMPageComponent implements OnInit {

  public coreConfig: any;

  public xAuthToken : any;
  public iframeUrl!: SafeResourceUrl;

  constructor(
    public route: ActivatedRoute,
    private _router: Router,
    private sanitizer: DomSanitizer,
    private masterDataService: MasterDataService,
    public toast: ToastrService,
    private _coreConfigService: CoreConfigService) {

    this._coreConfigService.config = {
      layout: {
        navbar: { hidden: true },
        menu: { hidden: true },
        footer: { hidden: true },
        customizer: false,
        enableLocalStorage: false
      }
    };
    // this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://example.com');
  }

  ngOnInit() {

    this.getEsimWebURL();

  }

  getEsimWebURL() {
    this.masterDataService.getEsimWebURL().subscribe(resp => {
          // window.open(resp.body["url"]);
          // this.iframeUrl = resp?.body["url"];
          this.loadUrl(resp?.body["url"])
    }, err => {
          this.toast.error(err.error.message);
    });
  }

  loadUrl(url: string) {
    this.iframeUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}

 
